import { apiGet, apiPatch } from './client';
import type { Role, RoleBatchRequest } from '../types/Role';

export function getRoles(): Promise<Role[]> {
  return apiGet<Role[]>('/api/roles');
}

export function saveBatchRoles(body: RoleBatchRequest): Promise<Role[]> {
  return apiPatch<RoleBatchRequest, Role[]>('/api/roles/batch', body);
}
